export default __webpack_public_path__ + "static/media/Facebook.d8e40d09.svg";